import React, { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { defaultImg } from "../Constants/Images";

interface ThumnailImageSliderType {
  images: Array<object> | undefined;
  thumbsCount?: number;
}

const ThumnailImageSlider: React.FC<ThumnailImageSliderType> = ({
  images,
  thumbsCount = 4,
}) => {
  const [screenWidth, setScrceenWidth] = useState(window.outerWidth);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setScrceenWidth(window.outerWidth);
    });
  }, [window.outerWidth]);

  if (images && images.length > 0) {
    return (
      <>
        <Swiper
          style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
          }}
          spaceBetween={15}
          navigation={images.length > 1 ? true : false}
          thumbs={{ swiper: thumbsSwiper }}
          modules={[FreeMode, Navigation, Thumbs]}
          className="top-slider"
        >
          {images.map((item, index) => (
            <SwiperSlide>
              <img src={item.url} alt="" />
            </SwiperSlide>
          ))}
        </Swiper>

        {images.length > 1 && (
          <Swiper
            onSwiper={setThumbsSwiper}
            spaceBetween={15}
            slidesPerView={
              screenWidth < 768 ? 2 : screenWidth < 1100 ? 4 : thumbsCount
            }
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs]}
            className="thumb-slider"
          >
            {images.map((item, index) => (
              <SwiperSlide key={`thumb-${index}`}>
                <img src={item && item.url} alt="" />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </>
    );
  } else {
    return (
      <div className="w-100">
        <img src={defaultImg} className="w-100" />
      </div>
    );
  }
};

export default ThumnailImageSlider;
